import React, {Component} from 'react';
import Styles from './style.css';
import {langRegister} from "../../services/langRegister";
import cx from "classnames";
import AnimateHeight from 'react-animate-height';

class FaqBuyWithUs extends Component {

    constructor(props) {
        super(props);
        this.state = {
            accordion: [],
            lang: "en",
            tab: []
        };
    };

    componentDidMount() {
        window.scrollTo(0, 0);
        this.setState({
            lang: this.props.lang,
            tab: this.props.tab
        }, () => {
            this._updateAccordion();
        });
    }

    componentWillReceiveProps(nextProps, nextState) {
        this.setState({
            lang: nextProps.lang,
            tab: nextProps.tab
        }, () => {
            this._updateAccordion();
        });
    }

    _updateAccordion() {

      let faq = "faq-buy";



        let accordion = [
            {
                title: langRegister.get(faq, "item_1", this.state.lang),
                text: langRegister.get(faq, "item_2", this.state.lang),
                height: 0
            }, {
                title: langRegister.get(faq, "item_3", this.state.lang),
                text: langRegister.get(faq, "item_4", this.state.lang),
                height: 0
            }, {
                title: langRegister.get(faq, "item_5", this.state.lang),
                text: langRegister.get(faq, "item_6", this.state.lang),
                height: 0
            }
        ];

        this.setState({accordion: accordion});
    }

    render() {
        return (
            <div>

                <div className={Styles.container}>
                    {
                        this.state.accordion.map((item, key) => {
                            return (
                                <div key={key} className={Styles.sectionEighteenItem}>
                                    <div onClick={() => {
                                        item.height = item.height === 0 ? 'auto' : 0;
                                        this.setState({accordion: this.state.accordion})
                                    }} className={Styles.sectionEighteenItemTitle}>
                                        {item.title}
                                        {
                                            item.height === 0 &&
                                            <img className={Styles.sectionEighteenItemIconPlusIcon}
                                                 src={require("../../assets/images/YL_plus_black.png")}/>
                                        }
                                        {
                                            item.height === "auto" &&
                                            <img className={Styles.sectionEighteenItemIconMinusIcon}
                                                 src={require("../../assets/images/YL_minus_black.png")}/>
                                        }
                                    </div>
                                    <AnimateHeight
                                        duration={100}
                                        height={item.height} // see props documentation bellow
                                    >
                                        <div className={Styles.sectionEighteenItemText}>{item.text}</div>
                                    </AnimateHeight>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        );
    }
}

export default FaqBuyWithUs;


// WEBPACK FOOTER //
// ./src/components/faq-buy-with-us/component.js